import { useTranslation } from 'react-i18next'


import { Feedback } from '@features/feedback'

//import { BannerApp } from '@widgets/app-banner'
// import { BlogPreview } from "@widgets/blog-preview";
// временно скрыто
import { Location } from '@widgets/location'
import { Quality } from '@widgets/quality'
import { Services } from '@widgets/services'


import SEO from '@shared/components/SEO'
import { BRAND_NAME } from '@shared/contants/app'
import Breadcrumbs from '@shared/ui/breadcrumbs'
import Container from '@shared/ui/container'
import Wrapper from '@shared/ui/wrapper'

import styles from './styles.module.scss'

export default function AboutPage () {
  const { t: ta } = useTranslation('about')
  const { t: ts } = useTranslation('seo')

  return (
    <Container>
      <SEO
        title={ts('about.title', { brand: BRAND_NAME })}
        description={ts ('about.description', { brand: BRAND_NAME })}
      />
      <Wrapper className={styles.wrapper}>
        <Breadcrumbs
          className={styles.breadcrumbs}
          links={[
            {
              title: ta('page'),
            },
          ]}
        />

        <div className={styles.container}>
          <div className={styles.content}>
            <h1>{ta('content.title')}</h1>

            <p>{ta('content.1')}</p>

            <div className={styles.block}>
              <Location />
            </div>

            <p>{ta('content.2')}</p>

            <div className={styles.block}>
              <Quality />
            </div>
            <div className={styles.block}>
              <Feedback />
            </div>
            <div className={styles.block}>
              <Services />
            </div>
            {/* <div className={styles.block}>
              <BlogPreview />
            </div> */}
            {/* временно скрыли БЛог превью */}
            {/* <div className={styles.block}>
              <BannerApp />
            </div> */}
          </div>
        </div>
      </Wrapper>
    </Container>
  )
}
